import React, { useState } from "react";
import { useKeenSlider } from "keen-slider/react";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import "keen-slider/keen-slider.min.css";

const inclusiveData = [
    {
        id: 1,
        title: "Women Leadership",
        desc: "Women LeadershipWe prioritize gender diversity at Cybage, with over 33% of our workforce being women, the highest rate in the country. This is a testament to our commitment to fostering an inclusive workplace."
    },
    {
        id: 2,
        title: "Mumployees",
        desc: "Our \"Mumployees\" initiative supports new moms with nursing rooms, work flexibility, and unique facilities, enabling them to pursue career goals while maintaining work-life balance."
    },
    {
        id: 3,
        title: "Inclusive policies",
        desc: "We have a zero-tolerance policy for sexual harassment, bribery, unethical conduct, and dignity violations. Our H"
    }
];

const InclusiveFuture = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        loop: true,
        slides: {
            perView: 1,
            spacing: 16,
        },
        breakpoints: {
            "screen and (min-width: 640px)": {
                slides: { perView: 2, spacing: 20 },
            },
            "screen and (min-width: 1024px)": {
                slides: { perView: 3, spacing: 20 },
            },
        },
    });

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 },
        },
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
    };

    return (
        <section className="w-full bg-white pb-12 sm:pb-16 md:pb-20 lg:pb-24 text-left relative z-10 overflow-hidden">
            <div className="max-w-[1440px] mx-auto w-full px-5 sm:px-10 lg:px-[80px]">

                <div className="text-center mb-10 sm:mb-14 md:mb-16 w-full">
                    <h2 className="text-[20px] md:text-[30px] font-[600] font-sora text-[#01386A] leading-tight tracking-tight">
                        Working Towards an Inclusive Future
                    </h2>
                </div>

                <motion.div
                    ref={sliderRef}
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    className="keen-slider w-full items-stretch"
                >
                    {inclusiveData.map((item) => (
                        <motion.div
                            key={item.id}
                            variants={cardVariants}
                            whileHover={{ transition: { duration: 0.3 } }}
                            className="keen-slider__slide flex"
                        >
                            <div className="group relative w-full bg-white border border-[#01386A45] p-6 sm:p-8 md:p-10 flex flex-col justify-between items-start min-h-[280px] sm:min-h-[320px] md:min-h-[350px] transition-shadow duration-300 hover:shadow-xl overflow-hidden h-full">

                                <h3 className="text-[16px] md:text-[20px] font-[600] font-sora text-[#01386A] leading-tight tracking-tight break-words w-full mb-4">
                                    {item.title}
                                </h3>

                                <p className="text-[14px] md:text-[16px] text-[#49577A] font-[500] font-graphik leading-relaxed break-words w-full mt-auto">
                                    {item.desc}
                                </p>

                                <div className="h-[4px] w-full absolute bottom-0 bg-[#01386A] left-0 overflow-hidden">
                                    <div className="h-full w-0 bg-[#ED6800] transition-all duration-500 ease-out group-hover:w-full"></div>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>

                <div className="flex items-center gap-3 w-full justify-start px-1 mt-8 sm:mt-10 md:mt-12">
                    <button
                        onClick={() => instanceRef.current?.prev()}
                        className="w-10 h-10 rounded-full border border-[#ED6800] text-[#ED6800] flex items-center justify-center bg-transparent hover:bg-[#ED6800] hover:text-white transition-all duration-300 cursor-pointer outline-none select-none"
                        title="Previous item"
                    >
                        <ArrowLeft size={18} />
                    </button>
                    <button
                        onClick={() => instanceRef.current?.next()}
                        className="w-10 h-10 rounded-full border border-[#ED6800] text-[#ED6800] flex items-center justify-center bg-transparent hover:bg-[#ED6800] hover:text-white transition-all duration-300 cursor-pointer outline-none select-none"
                        title="Next item"
                    >
                        <ArrowRight size={18} />
                    </button>
                </div>

            </div>
        </section>
    );
};

export default InclusiveFuture;